<template>
  <v-menu
    :class="{ 'v-menu__activator--disabled': !isSuccess }"
    :close-on-content-click="false"
    :open-on-click="false"
    offset-y
  >
    <v-btn
      slot="activator"
      :disabled="!isSuccess"
      flat
      @click="toggleDropdown"
    >
      <span class="toolbar__button-label">
        <span class="autocomplete__text">
          {{ label }}<span v-if="date"><br><strong>{{ moment(date).format('DD/MM/YYYY') }}</strong></span>
        </span>
      </span>

      <v-icon v-if="!date" right small>keyboard_arrow_right</v-icon>

      <v-icon
        v-if="date"
        id="menu-item__clear"
        color="accent"
        right
        small
        @click="toggleDropdown"
      >
        close
      </v-icon>
    </v-btn>

    <v-dialog
      v-model="dateDialog"
      :open-on-click="false"
      :close-on-content-click="false"
      lazy
      full-width
      width="290"
    >
      <v-date-picker
        v-model="date"
        :locale="currentLocale"
        :max="maxPeriodDate"
        color="accent"
        @change="(val) => closeDateDialog(val)"
      />
    </v-dialog>
  </v-menu>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'MenuItemStatus',
  props: {
    filters: Object,
    type: String,
    label: {
      type: String,
      require: true
    },
    status: {
      type: Number,
      default: STATUS_SUCCESS
    }
  },
  data () {
    return {
      menuContainer: false,
      isSelected: false,
      dateDialog: null,
      date: null
    }
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    },

    today () {
      return new Date().toJSON().slice(0, 10)
    },

    currentLocale () {
      return this.$i18n.locale.split('_').join('-')
    },

    maxPeriodDate () {
      return this.moment().format('YYYY-MM-DD')
    }
  },
  methods: {
    resetProps () {
      this.updateFilters()
      this.menuContainer = false
      this.isSelected = false
      this.dateDialog = null
      this.date = null
    },

    toggleDropdown ($event) {
      if ($event.target.id === 'menu-item__clear') {
        this.resetProps()
        return
      }

      this.openDateDialog()
    },

    updateFilters (date = null) {
      this.$emit('change', { [this.type]: date })
    },

    openDateDialog () {
      this.dateDialog = true
    },

    closeDateDialog (val) {
      this.dateDialog = false
      val && this.updateFilters(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar__button-label {
  line-height: 1.4;
  text-align: left;
}
</style>
